import styled from "styled-components";

const StyledSyndicDash = styled.div`
	height: 100vh;
	width: 100vw;
	background-color: var(--gray-2);
`;

export default StyledSyndicDash;
